import axios from "axios";
import { baseURL, REFRESH_URL } from "../API/API";

let refreshPromise = null;

export async function refreshAccessToken() {
  if (refreshPromise) {
    return refreshPromise;
  }

  refreshPromise = (async () => {
    const refreshToken = localStorage.getItem("refreshToken");
    if (!refreshToken) {
      throw new Error("No refresh token");
    }

    const response = await axios.post(
      `${baseURL}/${REFRESH_URL}`,
      { refresh_token: refreshToken },
      { withCredentials: true }
    );

    const newAccessToken = response.data?.access;
    if (!newAccessToken) {
      throw new Error("No access token in refresh response");
    }

    localStorage.setItem("accessToken", newAccessToken);
    return newAccessToken;
  })();

  try {
    return await refreshPromise;
  } finally {
    refreshPromise = null;
  }
}

export function clearAuthStorage() {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("user");
}
